import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import PropTypes from "prop-types";
import React, { memo } from "react";
import mapImports from "@xe/util-webpack-context";

var staticSvgContext = require.context("../svgs/static", true, /\.svg$/);

var staticSvgs = mapImports(staticSvgContext, function (str) {
  return str.split("/").slice(-1)[0];
});
var Emblem =
/*#__PURE__*/
memo(function Emblem(_ref) {
  var currencyCode = _ref.currencyCode,
      countryCode = _ref.countryCode,
      rest = _objectWithoutPropertiesLoose(_ref, ["currencyCode", "countryCode"]);

  var code = String(currencyCode != null ? currencyCode : countryCode).toLowerCase();
  return (
    /*#__PURE__*/
    React.createElement("img", _extends({
      alt: "",
      src: staticSvgs[code + ".static.svg"]
    }, rest))
  );
});
Emblem.propTypes = {
  currencyCode: PropTypes.string,
  countryCode: PropTypes.string
};
export default Emblem;